import { useState, useEffect, useRef } from "react";

const useUploadTimer = (durationInSeconds) => {
  const [remainingTime, setRemainingTime] = useState(durationInSeconds);
  const intervalRef = useRef(null);
  const endTimeRef = useRef(null);

  useEffect(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    if (!durationInSeconds || durationInSeconds <= 0) {
      setRemainingTime(0);
      return;
    }

    // 🔥 FIX: store exact end time
    endTimeRef.current = Date.now() + durationInSeconds * 1000;

    const updateTimer = () => {
      const diff = Math.floor(
        (endTimeRef.current - Date.now()) / 1000
      );

      if (diff <= 0) {
        clearInterval(intervalRef.current);
        setRemainingTime(0);
      } else {
        setRemainingTime(diff);
      }
    };

    // run immediately
    updateTimer();

    intervalRef.current = setInterval(updateTimer, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [durationInSeconds]);

  // ⏱ formatting
  const hours = Math.floor(remainingTime / 3600);
  const minutes = Math.floor((remainingTime % 3600) / 60);
  const seconds = remainingTime % 60;

  const formattedTime =
    hours > 0
      ? `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      : `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return {
    remainingTime,
    formattedTime,
    isExpired: remainingTime <= 0 && durationInSeconds > 0,
  };
};

export default useUploadTimer;
